import { useState } from 'react';
import clsx from 'clsx';
import SiteSettings from '../components/settings/SiteSettings';
import TeamMembers from '../components/settings/TeamMembers';
import { useAuth } from '../hooks/useAuth';

const tabs = [
  { id: 'site', label: 'Site Settings' },
  { id: 'team', label: 'Team Members' },
  { id: 'account', label: 'Account' },
] as const;

type TabId = (typeof tabs)[number]['id'];

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<TabId>('site');
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Settings</h1>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={clsx(
                'border-b-2 pb-3 text-sm font-medium transition-colors',
                activeTab === tab.id
                  ? 'border-brand-600 text-brand-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
              )}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'site' && <SiteSettings />}
      {activeTab === 'team' && <TeamMembers />}
      {activeTab === 'account' && (
        <div className="max-w-lg space-y-6">
          <div className="card">
            <h3 className="text-lg font-semibold text-gray-900">Account Details</h3>
            <div className="mt-4 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  defaultValue={user?.name}
                  className="input mt-1"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  defaultValue={user?.email}
                  className="input mt-1"
                  disabled
                />
              </div>
              <button className="btn-primary">Save Changes</button>
            </div>
          </div>

          <div className="card">
            <h3 className="text-lg font-semibold text-gray-900">Change Password</h3>
            <div className="mt-4 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Current Password
                </label>
                <input type="password" className="input mt-1" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">New Password</label>
                <input type="password" className="input mt-1" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Confirm New Password
                </label>
                <input type="password" className="input mt-1" />
              </div>
              <button className="btn-primary">Update Password</button>
            </div>
          </div>

          <div className="card border-red-200">
            <h3 className="text-lg font-semibold text-red-600">Danger Zone</h3>
            <p className="mt-2 text-sm text-gray-500">
              Once you delete your account, there is no going back. Please be certain.
            </p>
            <button className="btn-danger mt-4">Delete Account</button>
          </div>
        </div>
      )}
    </div>
  );
}
